import {ChangeDetectorRef, Component, ComponentFactoryResolver,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {Customer} from "../../../model/customer/customer";
import {TranslateService} from '@ngx-translate/core';
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {FieldRecord} from "../../../model/api/field-record";
import {FieldRequest} from "../../../model/api/field-request";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import {BankAccount} from "../../../model/customer/bank-account";
import {MoneyOwner} from "../../../model/customer/money-owner";
import {CustomerMoneyOwnerService} from "../../../services/customer/customer-money-owner.service";
import TYPE = FormFieldConfig.TYPE;
import {ReportTemplate} from "../../../model/archive/report-template";
import {ReportProfile} from "../../../model/archive/report-profile";

@Component({
  selector: 'app-money-owner',
  templateUrl: './money-owner.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class MoneyOwnerComponent extends CrudBaseComponent<MoneyOwner> {

  countries: FieldRecord<any>[]

  currencies: FieldRecord<any>[]

  owners: FieldRecord<any>[]

  bankAccounts: FieldRecord<BankAccount>[] = [];

  invoices: FieldRecord<ReportProfile>[] = [];

  constructor(cdref: ChangeDetectorRef,
              commonFieldService: CommonFieldService,
              customerMoneyOwnerService: CustomerMoneyOwnerService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = customerMoneyOwnerService;
    this.newRecord = new MoneyOwner();
  }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [
      {
        field: 'owner',
      },
      {
        field: 'code',
      },
      {
        field: 'description',
      },
      {
        field: 'country',
        icon: (value: Customer) => value.country ? 'flag-icon flag-icon-' + value.country.toLowerCase() : '',
        mapId: value => ''
      },
      {
        field: 'town',
      },
      {
        field: 'currency',
        icon: record => 'cc-ico',
        iconValue: record => {
          const currency = this.currencies ? this.currencies.find(value => value.id === record.currency) : undefined;
          if (currency)
            return currency.value
          return '';
        }
      },
      {
        field: 'vat',
        mapId: record => record.vat ? this.getTranslation("common.yes") : this.getTranslation("common.no")
      },
    ];


    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'ownerId',
            required: true,
            filter: true,
            column: 3,
            type: TYPE.DROPDOWN,
            options: () => this.owners,
            changed: event => {
              this.formRecord.ownerId = parseInt(event.value);
              this.formRecord.owner = this.findOptText(this.owners, event.value)
            }
          },
          {
            field: 'code',
            required: true,
            column: 4,
            type: TYPE.TEXT
          },
          {
            field: 'description',
            required: true,
            column: 5,
            type: TYPE.TEXT
          }]
      },
      {
        group: 'address',
        fields:
          [{
            field: 'address',
            column: 12,
            type: TYPE.TEXT
          },
            {
              field: 'zipCode',
              column: 2,
              type: TYPE.TEXT
            },
            {
              field: 'town',
              column: 4,
              type: TYPE.TEXT
            },
            {
              field: 'country',
              filter: true,
              column: 3,
              type: TYPE.DROPDOWN,
              icon: id => id ? ('flag-icon flag-icon-' + id.toLowerCase()) : '',
              options: () => this.countries,
              changed: event => this.formRecord.country = event.value.toUpperCase()
            },
            {
              field: 'stateAddress',
              column: 3,
              type: TYPE.TEXT
            },
          ]
      },
      {
        group: 'invoice_detail',
        fields: [
          {
            field: 'currency',
            column: 5,
            type: TYPE.DROPDOWN,
            filter: true,
            options: () => this.currencies,
            icon: id => 'cc-ico',
            iconValue: id => this.currencies && this.currencies.find(value => value.id === id) ?
              this.currencies.find(value => value.id === id).value : undefined
          },
          {
            field: 'billingDueNbDays',
            column: 2,
            type: TYPE.INTEGER
          },
          {
            field: 'bankAccountId',
            column: 5,
            type: TYPE.DROPDOWN,
            options: () => this.bankAccounts
          },
          {
            field: 'invoiceMail',
            column: 12,
            type: TYPE.TEXT
          },
          {
            field: 'vat',
            column: 3,
            type: TYPE.CHECKBOX
          },
          {
            field: 'vatNumber',
            column: 3,
            type: TYPE.TEXT
          },
          {
            field: 'invoiceTemplate',
            column: 3,
            type: TYPE.DROPDOWN,
            options: () => this.invoices
          },
        ]
      }

    ];
  }

  protected initData() {
    super.initData();

    this.settingsFormLoadingProgressValue = 0;
    let callCount = 5;
    this.commonFieldService.getCountries(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.countries = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.settingsFormLoadingProgressValue += 100 / callCount;
    })
    this.commonFieldService.getOwners(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.owners = this.getFields(fieldResult);
      this.settingsFormLoadingProgressValue += 100 / callCount;
    })
    this.commonFieldService.getCurrencies(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.settingsFormLoadingProgressValue += 100 / callCount;
      this.currencies = fieldResult.records ? [...this.getFields(fieldResult)] : [];
    });
    this.commonFieldService.getBankAccounts(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.settingsFormLoadingProgressValue += 100 / callCount;
      this.bankAccounts = fieldResult.records ? [...this.getFields(fieldResult)] : [];
    });
    this.commonFieldService.getInvoices(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.settingsFormLoadingProgressValue += 100 / callCount;
      this.invoices = fieldResult.records ? [...this.getFields(fieldResult)] : [];
    });
  }

}
